export enum FireInsuranceCancelReasonEnum {
  leaseGaveUp = "DESISTENCIA DA LOCACAO",
  endOfLease = "TERMINO DA LOCACAO",
  insuranceChange = "ALTERACAO DE SEGURO",
  others = "OUTROS",
}
